import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SHOW_VALIDATION_ERRORS_DIALOG } from "submission/submissionActions";
import { getValidationErrorsDialogVisible } from "common/selectors";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";

import IntlDialogActions from "../../general-components/IntlDialogActions";
import { getActiveStep, getFieldOptions } from "../../common/selectors";

const ValidationErrorsDialog = () => {
  const { t } = useTranslation();
  const visible = useSelector(getValidationErrorsDialogVisible);
  const activeStep = useSelector(getActiveStep);
  const fieldOptions = useSelector(getFieldOptions);

  /**
   * Custom error messages from field options for validation dialog
   * have shape of `submission_validation_error_message_key__${step_name}`
   * Split at double underscore (__) to get step name
   */
  const customErrorMessageFieldOptionKey = Object.keys(fieldOptions)
    ?.filter(key => key.startsWith("submission_validation_error_message_key__"))
    ?.filter(key => key.split("__")?.[1] === activeStep)?.[0];

  const customErrorMessageTranslationKey =
    fieldOptions?.[customErrorMessageFieldOptionKey]?.fieldLabel ??
    "submission_validation_error_message";

  const dispatch = useDispatch();
  const onCancel = () =>
    dispatch({ type: SHOW_VALIDATION_ERRORS_DIALOG, show: false });

  return (
    <Dialog
      open={visible}
      onClose={onCancel}
      aria-labelledby="invalid-submission-dialog-title"
      aria-describedby="invalid-submission-dialog-description"
    >
      <DialogTitle id="invalid-submission-dialog-title">
        {t("submission_validation_error_title")}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          color="primary"
          id="invalid-submission-dialog-description"
        >
          {t(customErrorMessageTranslationKey)}
        </DialogContentText>
      </DialogContent>

      <IntlDialogActions>
        <Button color="primary" onClick={onCancel}>
          {t("submission_validation_error_ok")}
        </Button>
      </IntlDialogActions>
    </Dialog>
  );
};

export default ValidationErrorsDialog;
